import React from "react";
import styles from "../../../../../BorrowerDetails.module.css";
import { useState, useEffect } from "react";
import { useBorrowerContext } from "../../../../../store/borrower-details";
import { TextField, MenuItem } from "@mui/material";
import axios from "axios";
import { url } from "../../../../../../../../App";
import MultiDocsModal from "../../../../Modals/MultiDocsModal";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { FaInfoCircle } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";

const CPV = ({ cpvUpload, permissions }) => {
  const { loanid } = useParams();
  const cpvLoanSelect = loanid;
  const { borrowerData } = useBorrowerContext();
  const fetchedCpvDetails = borrowerData.cpv;
  // const fetchedLoanDetails = borrowerData.loan;
  const [cpvModal, setCpvModal] = useState(false);
  const [cpvDocs, setCpvDocs] = useState([]);
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);
  const [cpvResponse, setCpvResponse] = useState({
    currentCpv: "",
    officeCpv: "",
    permanentCpv: "",
  });
  const fetchedLoanDetails = borrowerData.loan;
  const foundLoan = fetchedLoanDetails.find((item) => item.loan_id === loanid);
  const [isDisbursed, setIsDisbursed] = useState(false);
  const [isAddDoc, setIsAddDoc] = useState(false);
  const [isViewDoc, setIsViewDoc] = useState(false);
  const [isDownloadDoc, setIsDownloadDoc] = useState(false);
  const [isDeleteDoc, setIsDeleteDoc] = useState(false);
  const navigate = useNavigate();
  const email = Cookies.get('Email');
  const token = Cookies.get('Token');

  useEffect(() => {
    if (loanid) {
      setIsDisbursed(foundLoan?.loan_status === "DISBURSED");
    }
    //eslint-disable-next-line
  }, [foundLoan]);

  const showCurrentCpv = () => {
    const selectedCpv = fetchedCpvDetails.find(
      (cpv) => cpv.loan_id === cpvLoanSelect.toString()
    );

    if (
      !selectedCpv?.current_add_cpv ||
      !selectedCpv?.office_add_cpv ||
      !selectedCpv?.permanent_add_cpv
    ) {
      setCpvResponse({
        currentCpv: selectedCpv?.current_add_cpv || "",
        officeCpv: selectedCpv?.office_add_cpv || "",
        permanentCpv: selectedCpv?.permanent_add_cpv || "",
      });
      return;
    }

    setCpvResponse((prevState) => ({
      ...prevState,
      currentCpv: selectedCpv?.current_add_cpv,
      officeCpv: selectedCpv?.office_add_cpv,
      permanentCpv: selectedCpv?.permanent_add_cpv,
    }));
  };

  useEffect(() => {
    showCurrentCpv();
    checkCpvStatus();
    //eslint-disable-next-line
  }, [cpvLoanSelect]);

  const viewCpvHandler = async (docName) => {
    console.log(docName);
    setLoader(true);
    if (!cpvLoanSelect.toString()) {
      setLoader(false);
      toast.error("Please select a loan ID");
      return;
    }
    // console.log(docName);
    // console.log(cpvLoanSelect)
    const cpvArray = fetchedCpvDetails.find((data) => {
      return data.loan_id.toString() === cpvLoanSelect.toString();
    });
    if (!cpvArray) {
      toast.error("Document not found");
      setLoader(false);
      return;
    }
    if (cpvArray[docName] === undefined) {
      toast.error("Document not found");
      setLoader(false);
      return;
    }
    // console.log(cpvArray[docName]);
    const viewCpvArr = await Promise.all(
      cpvArray[docName].map(async (data, index) => {
        // console.log(data);
        const req = {
          token: Cookies.get("Token"),
          email: Cookies.get("Email"),
          borrower_uniqueno: localStorage.getItem("uniqueID"),
          doc_name: data.doc_name,
          doc_type: "pdf",
          loan_id: cpvLoanSelect,
        };

        const docNameArr = data.doc_name
          .split("(")[0]
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1));
        // console.log(docNameArr);
        const docName = `${docNameArr[0]} ${docNameArr[1]}ress CPV`;
        setName(docName);
        // console.log(deleteReq)
        const res = await axios.post(url + "/cpv/viewdoc", req);
        // console.log(req, res);

        const downloadCpvHandler = async () => {
          const downloadRes = await axios.post(url + "/cpv/downloaddoc", req);
          if (!downloadRes.data.auth) {
            toast.error(downloadRes.data.message);
            return;
          }
          const downloadLink = document.createElement("a");
          const linkSource = `data:application/pdf;base64,${downloadRes.data.doc_base64}`;
          const fileName = `${req.borrower_uniqueno} Loan${req.loan_id} ${req.doc_name}.pdf`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        };

        const deleteCpvHandelr = async () => {
          const text = `Are you sure you want to delete ${req.doc_name}?`;
          if (!window.confirm(text)) {
            return;
          }
          const deleteReq = {
            token: Cookies.get("Token"),
            email: Cookies.get("Email"),
            borrower_uniqueno: localStorage.getItem("uniqueID"),
            loan_id: cpvLoanSelect,
            doc_arr: {
              location: data.location,
              doc_type: "pdf",
              doc_name: data.doc_name,
            },
          };
          const deleteRes = await axios.post(url + "/cpv/deletedoc", deleteReq);
          // console.log(deleteReq)
          // console.log(deleteRes)
          if (!deleteRes.data.auth) {
            return toast.error(deleteRes.data.message);
          }
          toast.success(deleteRes.data.message);
          window.location.reload();
        };

        return {
          doc: res.data.doc_base64,
          docType: req.doc_type,
          download: downloadCpvHandler,
          delete: deleteCpvHandelr,
        };
      })
    );
    // console.log(viewCpvArr);
    if (viewCpvArr.length === 0) {
      toast.error("No docs found");
      setLoader(false);
      return;
    }
    setCpvDocs(viewCpvArr);
    // setViewCpvModal(true);
    setLoader(false);
    // console.log(viewCpvArr)
    setCpvModal(true);
  };

  const closeModal = () => {
    setCpvModal(false);
  };

  const checkCpvStatus = async () => {
    // console.log(e.target.value)
    // setCpvLoanSelect(e.target.value)
    try {
      let result = await axios.post(`${url}/cpv/find/cpvstatus`, {
        loanId: cpvLoanSelect,
        token: Cookies.get("Token"),
        email: Cookies.get("Email"),
      });
      console.log(result.data.cpvInitiated);
      // setCpvStatus(result.data.cpvInitiated)
    } catch (err) {
      console.log(err);
    }
  };

  const updateKey = (key, value) => {
    setCpvResponse((prevState) => ({
      ...prevState, // Spread the previous state
      [key]: value, // Update the specific key with the new value
    }));
  };

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setIsAddDoc(true);
      setIsViewDoc(true);
      setIsDeleteDoc(true);
      setIsDownloadDoc(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          console.log(res);
          setIsAddDoc(res.data[0].permission.add_cpv_doc);
          setIsViewDoc(res.data[0].permission.view_cpv_doc);
          setIsDeleteDoc(res.data[0].permission.delete_cpv_doc);
          setIsDownloadDoc(res.data[0].permission.download_cpv_doc);
          if (res.data.logout === true) {
            toast.error(res.data.message);
            setTimeout(() => {
              navigate("/");
            }, 3000);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.message);
        });
    }
  }, [token, email, navigate]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      {cpvModal && (
        <MultiDocsModal array={cpvDocs} closeModal={closeModal} title={name} isDelete={isDeleteDoc} isDownload={isDownloadDoc} />
      )}
      <div>
        <hr
          style={{
            backgroundColor: "gray",
            width: "100%",
            marginTop: "2rem",
            marginBottom: "1rem",
          }}
        />
        <div className="input-cpv">
          <label
            style={{
              marginLeft: ".5rem",
              fontSize: "12px",
            }}
          >
            Resident CPV Response
          </label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
              className="lms-input-field"
              variant="outlined"
              select
              required
              size="small"
              value={cpvResponse.currentCpv}
              sx={{ m: 1, width: "25ch" }}
              onChange={(e) => updateKey("currentCpv", e.target.value)}
              disabled={isDisbursed}
            >
              <MenuItem value="POSITIVE">POSITIVE</MenuItem>
              <MenuItem value="NEGATIVE">NEGATIVE</MenuItem>
              <MenuItem value="REFER TO CREDIT">REFER TO CREDIT</MenuItem>
            </TextField>
            <input
              type="file"
              onChange={(e) =>
                cpvUpload(
                  e,
                  "current_add_doc",
                  cpvResponse.currentCpv,
                  cpvLoanSelect
                )
              }
              disabled={isDisbursed}
              id="uploadLogo"
              hidden
            ></input>
            {isAddDoc && (
              <label
                className={styles.uploadcpv}
                style={{ fontSize: "12px" }}
                htmlFor="uploadLogo"
              >
                Upload CPV
              </label>
            )}
            {isViewDoc && (
            <button
              onClick={() => viewCpvHandler("current_add_doc")}
              className={styles.uploadcpv}
              style={{ fontSize: "12px" }}
            >
              View CPV
            </button>
            )}
            {fetchedCpvDetails.find((obj) => obj?.loan_id === cpvLoanSelect)
              ?.current_add_doc?.length > 0 ? (
              <div>
                <Tooltip
                  title={
                    fetchedCpvDetails.find(
                      (obj) => obj?.loan_id === cpvLoanSelect
                    )?.current_add_doc.length + " CPV Document Stored"
                  }
                >
                  <p style={{ marginLeft: "1rem", cursor: "pointer" }}>
                    <FaInfoCircle size={18} color="green" />
                  </p>
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <br></br>
        <div className="input-cpv">
          <label
            style={{
              marginLeft: ".5rem",
              fontSize: "12px",
            }}
          >
            Office CPV Response
          </label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
              className="lms-input-field"
              select
              variant="outlined"
              required
              size="small"
              value={cpvResponse?.officeCpv}
              sx={{ m: 1, width: "25ch" }}
              onChange={(e) => updateKey("officeCpv", e.target.value)}
              disabled={isDisbursed}
            >
              <MenuItem value="POSITIVE">POSITIVE</MenuItem>
              <MenuItem value="NEGATIVE">NEGATIVE</MenuItem>
              <MenuItem value="REFER TO CREDIT">REFER TO CREDIT</MenuItem>
            </TextField>

            <input
              type="file"
              onChange={(e) =>
                cpvUpload(
                  e,
                  "office_add_doc",
                  cpvResponse.officeCpv,
                  cpvLoanSelect
                )
              }
              id="uploadLogo1"
              hidden
              disabled={isDisbursed}
            ></input>
            {isAddDoc && (
            <label
              className={styles.uploadcpv}
              style={{ fontSize: "12px" }}
              htmlFor="uploadLogo1"
            >
              Upload CPV
            </label>
            )}
            {isViewDoc && (
            <button
              onClick={() => viewCpvHandler("office_add_doc")}
              className={styles.uploadcpv}
              style={{ fontSize: "12px" }}
            >
              View CPV
            </button>
            )}
            {fetchedCpvDetails.find((obj) => obj?.loan_id === cpvLoanSelect)
              ?.office_add_doc?.length > 0 ? (
              <div>
                <Tooltip
                  title={
                    fetchedCpvDetails.find(
                      (obj) => obj?.loan_id === cpvLoanSelect
                    )?.office_add_doc.length + " CPV Document Stored"
                  }
                >
                  <p style={{ marginLeft: "1rem", cursor: "pointer" }}>
                    <FaInfoCircle size={18} color="green" />
                  </p>
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <br></br>
        <div className="input-cpv">
          <label
            style={{
              marginLeft: ".5rem",
              fontSize: "12px",
            }}
          >
            Permanent CPV Response
          </label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <TextField
              className="lms-input-field"
              select
              variant="outlined"
              required
              size="small"
              value={cpvResponse?.permanentCpv}
              sx={{ m: 1, width: "25ch" }}
              onChange={(e) => updateKey("permanentCpv", e.target.value)}
              disabled={isDisbursed}
            >
              <MenuItem value="POSITIVE">POSITIVE</MenuItem>
              <MenuItem value="NEGATIVE">NEGATIVE</MenuItem>
              <MenuItem value="REFER TO CREDIT">REFER TO CREDIT</MenuItem>
            </TextField>

            <input
              type="file"
              onChange={(e) =>
                cpvUpload(
                  e,
                  "permanent_add_doc",
                  cpvResponse.permanentCpv,
                  cpvLoanSelect
                )
              }
              id="uploadLogo2"
              hidden
              disabled={isDisbursed}
            ></input>
            {isAddDoc && (
            <label
              className={styles.uploadcpv}
              style={{ fontSize: "12px" }}
              htmlFor="uploadLogo2"
            >
              Upload CPV
            </label>
            )}
            {isViewDoc && (
            <button
              onClick={() => viewCpvHandler("permanent_add_doc")}
              className={styles.uploadcpv}
              style={{ fontSize: "12px" }}
            >
              View CPV
            </button>
            )}
            {fetchedCpvDetails.find((obj) => obj?.loan_id === cpvLoanSelect)
              ?.permanent_add_doc?.length > 0 ? (
              <div>
                <Tooltip
                  title={
                    fetchedCpvDetails.find(
                      (obj) => obj?.loan_id === cpvLoanSelect
                    )?.permanent_add_doc.length + " CPV Document Stored"
                  }
                >
                  <p style={{ marginLeft: "1rem", cursor: "pointer" }}>
                    <FaInfoCircle size={18} color="green" />
                  </p>
                </Tooltip>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CPV;
